<header
  class="header fixed !bg-background-default flex items-center z-[40]"
  [ngClass]="{
    'header--shrink':
      menuIsOpen &&
      screenSize !== 'xSmall' &&
      screenSize !== 'small' &&
      screenSize !== 'medium',
    'header--small': screenSize === 'xSmall',
    'header--large': screenSize !== 'xSmall',
  }"
>
  <div class="w-full flex justify-between">
    <div class="flex items-center gap-2">
      @if (canGoBack) {
        <button
          (click)="goBack()"
          class="flex justify-center items-center p-1 text-primary-main hover:text-primary-dark rounded-full transition-colors rotate-180 mt-1 border"
          aria-label="Go back"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }

      <h3
        class="!text-[0.8rem] min-[420px]:!text-[1rem] sm:!text-[1.375rem] !font-bold pt-3 h-[48px] !text-primary-main"
      >
        {{ pageTitle | translate }}
      </h3>
    </div>

    <div id="page-header-payload-box" class="flex items-center gap-2"></div>
  </div>
</header>
